angular.module('vastdesk').
  component('enableGeoGroupsButton', {
    template: require("../templates/enableGeoGroupsButton.html"),
    controllerAs: '$enableGeoGroupsButtonCtrl',
    controller: ['$element', function($element) {
      var wrapper = $element.closest('.geo-toggle-wrapper-root');

      var DIMENSIONS = {
        country: { model: 'CountryList', valuesField: 'country_codes' },
        state: { model: 'StateList', valuesField: 'state_codes' },
        city: { model: 'CityList', valuesField: 'city_codes' },
        metro_area: { model: 'MetroAreaList', valuesField: 'metro_area_codes' },
        postal_code: { model: 'PostalCodeList', valuesField: 'postal_codes' }
      };

      this.enable = function() {
        var groupsRoot = wrapper.find('grouped-associations');
        var addGroupBtn = groupsRoot.find('.addgroup');
        var group = null;

        Object.keys(DIMENSIONS).forEach(function(dim) {
          var meta = DIMENSIONS[dim];
          var componentName = dim.replace(/_([a-z])/g, function(_, c) { return c.toUpperCase(); }) + 'Targeting';
          var tagName = componentName.replace(/([A-Z])/g, '-$1').toLowerCase();
          var componentEl = wrapper.find(tagName);
          var ctrl = angular.element(componentEl).controller(componentName);
          if (!ctrl || !ctrl.geoSource) return;

          var listType = ctrl.allowList === 'false' ? 'block_list' : 'allow_list';
          var associationIdsAttr = dim + '_list_ids';
          var fieldName = ctrl.geoSource === 'values' ? meta.valuesField : associationIdsAttr;
          var sourceSelect = componentEl.find('select[name*="[' + fieldName + '][]"]');
          if (!sourceSelect.val() || !sourceSelect.val().length) return;

          var addForm;
          if (!group) {
            addGroupBtn.trigger('click');
            group = groupsRoot.find('div:not(.newgroup) > .associationGroup').last();
            addForm = group.find('.add_form').last();
          } else {
            group.find('.add_fields').trigger('click');
            addForm = group.find('.add_form').last();
          }

          populateGeoGroup(addForm, meta.model, ctrl.geoSource, listType, associationIdsAttr, sourceSelect);
        });

        wrapper.find('[js-role="flat-geo-fields"]').addClass('hidden');

        var hasGroups = groupsRoot.find('div:not(.newgroup) > .associationGroup:not(.hidden)').length > 0;
        var toggleEl = wrapper.find('geo-groups-view-toggle');
        var toggleCtrl = angular.element(toggleEl).controller('geoGroupsViewToggle');
        if (toggleCtrl) toggleCtrl.setValue(hasGroups);
        toggleEl.removeClass('hidden');
      };

      function populateGeoGroup(addForm, geoObjectModel, sourceType, listType, associationIdsAttr, sourceSelect) {
        addForm.find('.geo-object select').val(geoObjectModel).trigger('change');
        function checkToggleButton(input) {
          input.prop('checked', true);
          var label = input.closest('label');
          label.siblings('label').removeClass('active');
          label.addClass('active');
          return input;
        }

        checkToggleButton(addForm.find('.geo-source-type input[value="' + sourceType + '"]')).trigger('change');
        checkToggleButton(addForm.find('.geo-list-type input[value="' + listType + '"]'));

        var destSelect = sourceType === 'values'
          ? addForm.find('.geo-values.geo-' + associationIdsAttr + ' select')
          : addForm.find('.geo-list-ids.geo-' + associationIdsAttr + ' select');

        var pairs = sourceSelect.find('option:selected').map(function() {
          return { value: $(this).val(), text: $(this).text() };
        }).get();

        if (destSelect.get(0) && destSelect.get(0).tomselect) {
          destSelect[0].tomselect.addOptions(pairs);
          destSelect[0].tomselect.addItems(pairs.map(function(p) { return p.value; }));
        } else {
          pairs.forEach(function(p) {
            destSelect.append($('<option>', { value: p.value, text: p.text, selected: true }));
          });
          destSelect.trigger('chosen:updated').trigger('change');
        }
      }
    }]
});
